const fromUrlValue = (urlValue: string, conversionObject: Record<string, string>): string =>
    Object.keys(conversionObject).find((key) => conversionObject[key] === urlValue) || urlValue;

const toUrlValue = (value: string, conversionObject: Record<string, string>): string =>
    conversionObject[value] ? conversionObject[value] : value;

export const toUrlValues = (
    values: string | string[] | undefined,
    conversionObject: Record<string, string>,
): string | string[] | undefined => {
    if (values) {
        if (Array.isArray(values)) {
            return values.map((value) => toUrlValue(value, conversionObject));
        }
        return toUrlValue(values, conversionObject);
    }
    return undefined;
};

export const fromUrlValues = (
    values: string | string[] | undefined,
    conversionObject: Record<string, string>,
): string | string[] | undefined => {
    if (values) {
        if (Array.isArray(values)) {
            return values.map((value) => fromUrlValue(value, conversionObject));
        }
        return fromUrlValue(values, conversionObject);
    }
    return undefined;
};
